import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';

import { parseOrbitExplorerOpenQuery } from './orbit-explorer-navigation.util';
import { OrbitOpenContextService } from './orbit-open-context.service';
import { isOrbitExplorerDeepLink } from './orbit-open-prefill.util';

/** Empty `/orbit-explorer/orbit` landings go to Explorer — no auth, no legacy dropdowns. */
export const orbitOpenFocusGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const openContext = inject(OrbitOpenContextService);
  const fromUrl = parseOrbitExplorerOpenQuery(route.queryParamMap);
  if (fromUrl) {
    openContext.setOpenQuery(fromUrl);
  }

  if (isOrbitExplorerDeepLink(openContext.openQuery())) {
    return true;
  }

  openContext.clear();
  return router.createUrlTree(['/orbit-explorer']);
};
